var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1768 2.17678C19.2744 2.07915 19.2744 1.92085 19.1768 1.82322L17.5858 0.232233C17.4882 0.134602 17.3299 0.134602 17.2322 0.232233C17.1346 0.329864 17.1346 0.488155 17.2322 0.585786L18.6464 2L17.2322 3.41421C17.1346 3.51184 17.1346 3.67014 17.2322 3.76777C17.3299 3.8654 17.4882 3.8654 17.5858 3.76777L19.1768 2.17678ZM0 2.25H19V1.75H0V2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8b3e885786b79543a555c22237ae0fb6.svg";
export { ForwardRef as ReactComponent };